import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Eye } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("mark@ozcast.com");
  const [password, setPassword] = useState("ozcast2026");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Authenticated. Welcome back, Mark.");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-bg min-h-screen flex items-center justify-center px-6 relative">
      <div className="max-w-md w-full oz-card p-8 relative z-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 flex items-center justify-center" style={{ background: "var(--oz-emerald)" }}>
            <Eye size={18} weight="fill" color="#fff" />
          </div>
          <div>
            <div className="font-display text-lg font-semibold tracking-tight">The OZ Cast</div>
            <div className="overline">AI Chief Operating Officer</div>
          </div>
        </div>

        <div className="mb-6">
          <h1 className="font-display text-3xl tracking-tight mb-1">Command Access</h1>
          <p className="text-sm text-[color:var(--oz-text-dim)]">
            Authenticate to enter the operating system.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="overline block mb-1.5">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 text-sm bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] rounded-sm focus:outline-none focus:border-[color:var(--oz-emerald)] transition-colors"
              required
            />
          </div>
          <div>
            <label className="overline block mb-1.5">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 text-sm bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] rounded-sm focus:outline-none focus:border-[color:var(--oz-emerald)] transition-colors font-mono"
              required
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={submitting}
            className="btn-primary w-full text-sm"
          >
            {submitting ? "Verifying…" : "Enter"}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-[color:var(--oz-border)] text-xs text-[color:var(--oz-text-muted)] font-mono">
          Default: mark@ozcast.com / ozcast2026
        </div>
      </div>
    </div>
  );
}
